































































import {
  Vue, Component, Prop, Watch, PropSync,
} from 'vue-property-decorator';
import {
  PartnersApi, DocumentRequest, UserApi, User, Partner,
} from '@compassdigital/foodworks.ts.sdk';
import Textfield from '@/components/Form/Textfield/index.vue';

@Component({
  components: {
    Textfield,
  },
})
export default class CommonWorkingDay extends Vue {
  @PropSync('eventInfo', {}) eventInfoLocal: any;

  @Prop() updatedDate!: any;

  @Prop() saving!: boolean;

  public edit: boolean = false;

  public menu: boolean = false;

  eventDateRules = [(v: any) => !!v || 'Cannot be left empty'];

  public save(date: any) {
    const currentDate = new Date();
    // eslint-disable-next-line
  }

  private eventItems = [
    {
      text: 'Holidays',
      value: 'Holidays',
    },
    {
      text: 'Other',
      value: 'Other',
    },
  ];

  public onCancel() {
    this.$emit('close');
  }

  public onCheck() {
    this.$emit('onSaveEvent');
  }

  public async onSave() {
    //
  }
}
